import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useMemo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { IconButton } from '../IconButton/index';
import { TextLinkInline } from '../TextLinkInline/index';
import { modifiers } from './constants';
const verticalPadding = 11;
const variationStyles = {
    [modifiers.informative]: theme.colors.gray800,
    [modifiers.negative]: theme.colors.negative800,
    [modifiers.notice]: theme.colors.notice800,
    [modifiers.positive]: theme.colors.positive800,
};
const actionLinkStyles = css `
  ${theme.typeStyles.bodySmallStyles}
  ${theme.typeStyles.bodyBoldStyles}
  color: ${theme.colors.gray100};
  margin-left: ${theme.spacing.x2};
`;
const defaultProps = {
    modifier: modifiers.informative,
    position: 'fixed',
};
const SnackbarAlert = ({ actionIconType, actionOnClick = () => { }, actionText, modifier = defaultProps.modifier, position = defaultProps.position, text, }) => {
    const containerStyles = useMemo(() => (css `
        bottom: 0;
        display: flex;
        justify-content: center;
        margin-bottom: ${theme.spacing.x4};
        position: ${position};
        width: 100%;
      `), [
        position,
    ]);
    const snackbarAlertStyles = useMemo(() => (css `
        ${theme.typeStyles.bodySmallStyles}
        align-items: center;
        background-color: ${variationStyles[modifier]};
        border-radius: ${theme.spacing.base};
        color: ${theme.colors.gray100};
        display: flex;
        padding-bottom: ${styleUtils.rem(verticalPadding)};
        padding-left: ${theme.spacing.x6};
        padding-right: ${theme.spacing.x6};
        padding-top: ${styleUtils.rem(verticalPadding)};
        z-index: 9999;
      `), [
        modifier,
    ]);
    const actionComponent = useMemo(() => {
        if (!actionIconType && actionText) {
            return (_jsx(TextLinkInline, { hasUnderline: false, hasUnderlineOnHover: true, onClick: (event) => {
                    event.preventDefault();
                    actionOnClick();
                }, text: actionText }));
        }
        else if (actionIconType && !actionText) {
            return (_jsx(IconButton, { iconType: actionIconType, onClick: actionOnClick, size: "large", type: "secondary" }));
        }
        return null;
    }, [
        actionIconType,
        actionText,
        actionOnClick,
    ]);
    return (_jsx("div", Object.assign({ css: containerStyles }, { children: _jsxs("div", Object.assign({ css: snackbarAlertStyles }, { children: [_jsx("span", { children: text }), actionComponent
                    && (_jsx("div", Object.assign({ css: actionLinkStyles }, { children: actionComponent })))] })) })));
};
const MemoizedSnackbarAlert = memo(SnackbarAlert);
export { MemoizedSnackbarAlert as SnackbarAlert };
// MC-1068 Temporary hack for Storybook.
export default SnackbarAlert;
